import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { useAuthStore } from "../../../../user/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface OrderData {
    order_idx: number;
    order_date: string;
    order_date_full: string;
    order_number: string;
    delivery_immediate: boolean;
    status_info: {
        order_status: number;
        order_status_text: string;
    };
    product_info: {
        product_idx: number;
        product_image: {
            file_idx: number;
            file_name: string;
            original_name: string;
        };
        product_category: string;
        product_name: string;
        product_amount: number;
        recipient_info: {
            recipient_name: string;
            recipient_mobile: string;
            delivery_date: string;
            delivery_time: string;
            delivery_post: string;
            delivery_address: string;
            delivery_address_detail: string;
        };
    };
    recipient_info: {
        delivery_address: string;
        delivery_address_detail: string;
        delivery_date: string;
        delivery_post: string;
        delivery_time: string;
        recipient_mobile: string;
        recipient_name: string;
    };
}

interface GetMemberResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: OrderData[];
}

export const useGetOrder = (
    page: number,
    search?: string,
    searchtxt?: string,
    start_date?: string,
    end_date?: string,
): UseQueryResult<GetMemberResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemberResponse, Error>({
        queryKey: ["getOrderList", page, search, searchtxt, start_date, end_date],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.user.get_order}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    page,
                    limit: 10,
                    search,
                    searchtxt,
                    start_date,
                    end_date,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
